import axios from 'axios'

const CategoryService = {
  async get (params = {}) {
    return axios.get('admin/categories', { params })
  },

  async import (params = {}) {
    return axios.post('admin/utilities/import-categories', params)
  },

  async sync (params = {}) {
    return axios.post('admin/utilities/sync-categories', params)
  },

  async post (params = {}) {
    return axios.post('admin/categories', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/categories/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/categories/${data.id}`, { data })
  }
}

export default CategoryService
